var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "#151718"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4001_807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1376 20.6326H23.6622L24.672 16.5933H21.1376V14.5737C21.1376 13.5336 21.1376 12.554 23.1573 12.554H24.672V9.16103C24.3428 9.11761 23.0997 9.01965 21.7869 9.01965C19.0453 9.01965 17.0983 10.6929 17.0983 13.7658V16.5933H14.0688V20.6326H17.0983V29.2162H21.1376V20.6326Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4001_807"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 24.2358,
    height: 24.2358,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.82fe034f1685111ff5af642c0712340c.svg";
export { ForwardRef as ReactComponent };